import React from 'react';

interface FilterTabsProps<K extends string> {
  filters: { key: K; label: string }[];
  activeFilter: K;
  onFilterChange: (key: K) => void;
}

export function FilterTabs<K extends string>({ filters, activeFilter, onFilterChange }: FilterTabsProps<K>) {
  return (
    <div className="flex gap-2 mb-4 flex-wrap">
      {filters.map(({ key, label }) => (
        <button
          key={key}
          onClick={() => onFilterChange(key)}
          className={`px-3 py-1.5 rounded-md text-sm font-medium border transition-colors ${
            activeFilter === key
              ? 'bg-naviter-blue text-white border-naviter-blue'
              : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50 hover:text-gray-800'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default FilterTabs;
